import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  CategoryScale,
  Legend,
} from "chart.js";

// Register required Chart.js components
ChartJS.register(ArcElement, Tooltip, CategoryScale, Legend);

interface Props {
  evictionStats: Record<string, { individuals: number }>;
}

const riskColors: Record<string, string> = {
  "Low": "#008000",
  "Medium": "#ffff00",
  "High": "#ffa500",
  "Extreme": "#ff0000",
};

const IncidenceByRiskLevel: React.FC<Props> = ({ evictionStats }) => {
  if (!evictionStats || Object.keys(evictionStats).length === 0) {
    return <p>No data available</p>;
  }

  // Extract risk levels and corresponding data
  const labels = Object.keys(evictionStats);
  const values = labels.map((risk) => evictionStats[risk]?.individuals || 0);
  const colors = labels.map((risk) => riskColors[risk] || "#888");

  const total = values.reduce((sum, value) => sum + value, 0);

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false }, // 
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const value = tooltipItem.raw;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${value} individuals (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="w-48 h-48 flex justify-center">
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default IncidenceByRiskLevel;
